import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useWallet } from '@demox-labs/aleo-wallet-adapter-react';
import { get_user_collections, loadCollectionData } from 'lib/client/aleo';
import { useAlert } from 'react-alert';



async function loadUserWalletCollections(
	publicKey, requestRecords, alert, setCategory, loading, setLoading, setData
) {
	if (loading)
		return
	setLoading(true);

	const collections_data = await get_user_collections(publicKey, requestRecords);
	const collections = await Promise.all(
		collections_data.map(loadCollectionData)
	);
	setData(collections);

	setLoading(false);
}


const Collections = ({ setCategory }) => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const { publicKey, requestRecords } = useWallet();
	const alert = useAlert();

	useEffect(() => {
		loadUserWalletCollections(
			publicKey, requestRecords, alert, setCategory, loading, setLoading, setData
		);
	}, [publicKey]);

	return (
		<>
			{/* <!-- Activity Tab --> */}
			<div className="tab-pane fade">
				{/* <!-- Records / Filter --> */}
				<div className="lg:flex" style={{
					flexFlow: 'column'
				}}>
					{/* <!-- Records --> */}
					<div className="mb-10 shrink-0 basis-8/12 space-y-5 lg:mb-0 lg:pr-10">
						{loading && (
							<div className="flex justify-center items-center">
								<div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-jacarta-500">
								</div>
							</div>
						)
						}
						{
							(!loading && data.length === 0) && (
								<div className="flex justify-center items-center">
									<div className="text-center">
										<div className="text-2xl font-semibold mb-2">No collection found</div>
										<div className="text-sm text-jacarta-500 dark:text-jacarta-400 normal-case	">
											Create one to begin minting NFTs
										</div>
									</div>
								</div>
							)
						}
						{!loading && data.map((collection) => {
							return (
								<Link href={`/collection/${collection.hex_id}`} key={collection.hex_id}>
									<a style={{
										flexDirection: "row",
										justifyContent: "space-between"

									}} className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl relative flex items-center border bg-white p-8 transition-shadow hover:shadow-lg">
										<div
											style={{
												flexDirection: "row",
												display: "flex"
											}}
										>
											<figure className="mr-5 self-start">
												<Image
													src={collection.public_data.metadata.icon_url}
													alt={collection.public_data.metadata.name}
													height={50}
													width={50}
													objectFit="cover"
													className="rounded-2lg"
													loading="lazy"
												/>
											</figure>

											<div>
												<h3 className="font-display text-jacarta-700 mb-1 text-base font-semibold dark:text-white">
													{collection.public_data.metadata.name}
												</h3>
												<span className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm">
													{collection.public_data.metadata.ticker}
												</span>
												<span className="text-jacarta-300 block text-xs normal-case">Tokens <strong className="uppercase">{collection.public_data.publicizable ? "can" : "cannot"}</strong> be made public. Tokens <strong className="uppercase">{collection.data.updatable ? "can" : "cannot"}</strong> be updated/burned.</span>
											</div>
										</div>
										{/*transfer button */}
										<ul className="flex flex-wrap items-center">
											<li className="my-1 mr-2.5" >
												<Link href={`/collection/${collection.hex_id}/manage`}>
													<button
														className="transition delay-50 bg-blue-500  hover:scale-110 hover:bg-indigo-500 duration-150"
													>
														<div

															className={
																"dark:border-jacarta-600 group bg-accent border-jacarta-100 font-display flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors border-transparent text-white dark:border-transparent capitalize"
															}
														>
															<svg
																className={
																	"icon mr-1 h-4 w-4 transition-colors fill-white"
																}
															>
																<use xlinkHref={`/icons.svg#icon-details`}></use>
															</svg>
															<span>manage</span>
														</div>
													</button>
												</Link>
											</li>
										</ul>

									</a>
								</Link>
							);
						})}
					</div>

				</div>
			</div>
		</>
	);
};

export default Collections;
